export default __webpack_public_path__ + "static/media/info-bg.f342ebe2.jpg";